module.exports = __webpack_public_path__ + "ffc5d5cdca45429fb69142407177d6ad.pdf";